export interface GrupoModel {
  readonly nomeIntegracao: string;
  readonly descricao: string;
}

export enum Authoritie {
  ADMINISTRADOR = 'ADMINISTRADOR_ACESSO',
  INTEGRACAO_CONTABIL = 'INTEGRACAO_CONTABIL_ACESSO',
  ANALISTA_SAUDE = 'ANALISTA_SAUDE',
  PERITO_ORCAMENTO_AUTO_ONLINE = 'PERITO_ORCAMENTO_AUTO_ONLINE',
  ANALISTA_ASSISTENCIA_24H = 'ANALISTA_ASSISTENCIA_24H'
}

export const gruposList: GrupoModel[] = [
  // {nomeIntegracao: "CLIENTE", descricao: "Cliente"},
  // {nomeIntegracao: "PRESTADOR_ASSISTENCIA24H", descricao: "Prestador Assistência 24h"},
  // {nomeIntegracao: "SERVICOS_SAUDE", descricao: "Serviços Saúde"},
  { nomeIntegracao: "ADMINISTRADORES", descricao: "Administradores" },
  { nomeIntegracao: "INTEGRACAO_CONTABIL", descricao: "Contábil / Financeiro" },
  { nomeIntegracao: "ANALISTA_SAUDE", descricao: "Analista Serviços Saúde" },
  { nomeIntegracao: "PERITO_ORCAMENTO_AUTO_ONLINE", descricao: "Perito Orçamento Auto Online" },
  { nomeIntegracao: "ANALISTA_ASSISTENCIA_24H", descricao: "Analista Assistência 24h" },
  
];

export const GRUPO_DEFAULT = () => {
  return { nomeIntegracao: "", descricao: "" };
};

export const obterGrupoPorNomeIntegracao = (nomeIntegracao: string): GrupoModel | null => {
  return gruposList.find((grupo) => grupo.nomeIntegracao === nomeIntegracao) || null;
};
